import { PageBlock } from "@/shared/pageComposition";

import { RouteDescriptionBlock } from "./blocks/RouteDescriptionBlock";
import { MyRouteModel } from "./MyRoute.model";
import { RouteListSection } from "./sections/RouteListSection";

export const getMyRouteBlocks = (
    model: MyRouteModel,
): PageBlock<MyRouteModel>[] => [
    {
        key: "route-description",
        order: 10,
        isVisible: (currentModel) => !!currentModel.route.description,
        render: () => (
            <RouteDescriptionBlock description={model.route.description} />
        ),
    },
    {
        key: "route-list-section",
        order: 20,
        render: () => (
            <RouteListSection
                capabilities={model.capabilities}
                points={model.data.points}
                schedules={model.data.schedules}
            />
        ),
    },
];
